module.exports = __webpack_public_path__ + "img/light-tornado.5913c0d2.svg";